<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import branch_officesAPI from "../../../services/branch_offices/branch_officesAPI";
import CompanyAPI from "../../../services/company/companyAPI";
import CompanySSOAPI from "../../../services/sso/company/companySSO.API";
import { required, minLength } from 'vuelidate/lib/validators'
import Swal from "sweetalert2";


/**
 * Form elements component
 */

export default {
  page: {
    title: "Sedes",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    
  },

  data() {
    return {
      submitted: false,
      title: "Registro de Sede",
        items: [{
        text: 'Gestión empresa',
        href: '/forms/listado-empresa',
      },
      {
        text: 'Registro de sede',
        active: true,
      },
      
      ],

      checked: true,
      checked2: false,
      status: "accepted",
      status2: "not_accepted",
      selected: "A",
      errors: [],
      branch_officesData: {
        name: null,
        phone: null,
        address: null,
        company_id: this.$route.params.id,
        company_name: null,
      },
    };
  },

  validations: {
    branch_officesData: {
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(9)
      },
      address: {
        required,
      },
      company_id: {
        required,
      },
      company_name: {
        required,
      },

    },
  },

  methods: {



    save() {
 
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();


      if (this.$v.$invalid) { 
       
        console.groupEnd();
        return;
      } else {

        console.group("Data que será registrada: ");
        console.log(this.branch_officesData);
        console.groupEnd();

        branch_officesAPI.createBranchOffice(this.branch_officesData)
          .then((resp) => {
            console.log(resp);
            Swal.fire({
                title: "Se ha registrado con exito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            if (resp.message === 'branch_office creado con exito') {
 
              this.$router.go(-1);
            }
          })
          .catch((err) => {
            console.log("Error al guardar Sede: ", err);
          });

      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getCompany() {
      CompanyAPI.getCompany(this.$route.params.id)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((response) => {
              this.branch_officesData.company_name = response.social_reason;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getCompany();

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title mb-4">Registro de Sede</h4>
              </div>

              <div class="col-6 text-right">
                <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6">
                <div class="card-body">
                  <form class="form-horizontal form-group" role="form" @submit.prevent="save">
                    
                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Nombre de la empresa"
                      label-for="company">
                    <b-form-input type="text" id="company" placeholder="" v-model="branch_officesData.company_name"
                        disabled></b-form-input>
                    </b-form-group>

                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Nombre de la sede" label-for="name">
                      <b-form-input type="text" id="name" maxlength="45" placeholder="Ingrese el nombre de la sede"
                        v-model="branch_officesData.name" :class="{
                          'is-invalid':
                            $v.branch_officesData.name.$error && submitted,
                        }"></b-form-input>
                      <div v-if="submitted && $v.branch_officesData.name.$error">
                        <small v-if="!$v.branch_officesData.name.required" class="text-danger">
                          <b>El nombre es requerido</b>
                        </small>
                      </div>
                    </b-form-group>


                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Teléfono" label-for="phone">
                      <b-form-input maxlength="10" type="tel" autocomplete="off"
                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" id="phone"
                        placeholder="Ingrese el número telefónico de la sede" v-model="branch_officesData.phone" :class="{
                          'is-invalid':
                            $v.branch_officesData.phone.$error && submitted,
                        }"></b-form-input>
                      <div v-if="submitted && $v.branch_officesData.phone.$error">
                        <small v-if="!$v.branch_officesData.phone.required" class="text-danger">
                          <b>El número telefónico es requerido</b>
                        </small>
                        <small v-if="!$v.branch_officesData.phone.minLength" class="text-danger">
                          <b>Minimo de numeros es 10</b>
                        </small>
                      </div>
                    </b-form-group>


                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Dirección" label-for="address">
                      <b-form-input type="text" maxlength="45" id="address" placeholder="Ingrese la dirección de la sede"
                        v-model="branch_officesData.address" :class="{
                          'is-invalid':
                            $v.branch_officesData.address.$error && submitted,
                        }"></b-form-input>
                      <div v-if="submitted && $v.branch_officesData.address.$error">
                        <small v-if="!$v.branch_officesData.address.required" class="text-danger">
                          <b>La dirección de la sede es requerida</b>
                        </small>
                      </div>
                    </b-form-group>

                    <input type="hidden" v-model="branch_officesData.company_id" />

                    <div class="form-group text-right m-b-0">
                      <button id="save" class="btn btn-primary" type="submit">
                        Guardar
                      </button>
                       <button type="button" @click="goBack" class="btn btn-secondary m-l-5 ml-1">
                        Cancelar
                      </button>
                       
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
